// extracted by mini-css-extract-plugin
export default {"Sidebar":"SidebarWoolworth_Sidebar__3aiVu"};